import React from 'react';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import ArrowDropDown from '@material-ui/icons/ArrowDropDown';
import CircularProgress from '@material-ui/core/CircularProgress';

var movil=/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

const getLabelWidth = (label, required)=>{
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  context.font = '15px sans-serif'; //getComputedStyle(document.body).font;

  return context.measureText(label).width + (required ? 8 : 1); 
}

const iconLoading = () =>{
  return (<div style ={{ marginRight: 15, marginTop: 4, marginBottom: 2 }} >
          <CircularProgress color="secondary" size={22} />
          </div>
          )
}

class SimpleSelect extends React.Component {
constructor (props) {
  super(props);
  this.state = {
    labelWidth: 0,
  }
}  

componentDidMount() {
  if (this.props.Outlined)
  this.setState({ labelWidth: this.props.labelWidth === undefined ? getLabelWidth(this.props.Label, this.props.required) : this.props.labelWidth})
}  

render() {
  const InputProps = this.props.Outlined === true ? undefined : ({ disableUnderline: this.props.disableUnderline });
   
  return (   
        <FormControl className={this.props.Style} variant= { this.props.Outlined === true ? 'outlined' : 'standard'} disabled={this.props.disabled}>
         {   
          (() => {

            if (this.props.hiddenLabel !== true)
            {
            return (
            <InputLabel id={this.props.Label} style={{ background: 'transparent' }} shrink={this.props.shrink} required={this.props.required} variant="outlined">{this.props.Label}</InputLabel>
            );
            }
            })()
         }
         <Select
           value= {this.props.Selected}
           onChange= {this.props.onChange}
           onClick = { movil === true ? (e)=> { e.preventDefault(); e.stopPropagation(); } : this.props.onClick }
           onTouchStart= { movil === true ? this.props.onTouchStart : undefined }
           inputProps={{ inputRef: this.props.Ref, autoFocus: this.props.AutoFocus, className: this.props.classNameInput }}  
           MenuProps={{ style: { zIndex: 400000 } }}
           input={ this.props.Outlined === true ? <OutlinedInput id ={this.props.id} labelWidth={ this.state.labelWidth } notched={this.props.shrink} style={{ paddingLeft: "15px"}}/> :  
                                                  undefined 
                 }
           multiple={this.props.Multiple}
           renderValue={this.props.RenderValue}
           onClose = {this.props.onClose}
           style={this.props.SelectClass}
           IconComponent= {this.props.loading ? iconLoading : this.props.IconComponent !== undefined ? this.props.IconComponent : ArrowDropDown} 
           onFocus={this.props.onFocus}
           onBlur = {this.props.onBlur}
           onOpen={this.props.onOpen}
           onMouseMove={this.props.onMouseMove}
           onMouseLeave={this.props.onMouseLeave}
           open={this.props.open}
           SelectDisplayProps={{ style: this.props.styleSelectDisplay }}
           label={this.props.Label}
           name={this.props.name}
           { ...InputProps }           
         >
         {                    
           (() => {
             if (this.props.ShowItemNone === true) {               
              if (this.props.customItemNone !== undefined && this.props.customItemNone !== null)
              {
                  return this.props.customItemNone;
              }
              else
              {
                return <MenuItem value={this.props.ValueItemNone}><em>{this.props.LabelItemNone}</em></MenuItem>;
              }
             }           
            })()
        }
        {this.props.Datos}
         </Select>
        </FormControl>
  );
}
}

export default SimpleSelect;
